<template>
  <section ref="section" class="section -indented -cta content-slider">
    <h2 :class="legendClassName">{{ legend }}</h2>

    <template v-if="isRefReady">
      <Transition name="content-slider" mode="out-in" :duration="650">
        <div :key="`${nameTitle}${text}`" :class="['section__content', { '-narrow': !isSmall }]">
          <h3 class="section__title content-slider__text">{{ nameTitle }}</h3>
          <RawHtml :html="text" class="content-slider__text" />

          <div v-if="links.length" class="content-slider__links content-slider__text">
            <h5 v-if="linksHeading" class="content-slider__links-heading">{{ linksHeading }}</h5>

            <a
              v-for="{ href, label } in links"
              :key="label"
              :href="href"
              target="_blank"
              rel="noopener"
              class="button -border -alt -link content-slider__links-label"
            >
              {{ label }}
            </a>
          </div>
          <slot />
        </div>
      </Transition>

      <div
        v-scroll:parallax="{ refNode: $refs.section, ratio: isSmall ? 0 : 0.075 }"
        :class="['section__image', { '-small': isSmall }]"
      >
        <Transition name="content-slider__image" mode="out-in">
          <div :key="image" :class="['content-slider__image', { '-small': isSmall }]">
            <Image v-if="image" class="content-slider__image-bg" :source="image" />
            <h4 v-if="slideTitle" class="content-slider__slide-title">{{ slideTitle }}</h4>
            <RawHtml v-if="slideText" :html="slideText" class="content-slider__slide-text" />
          </div>
        </Transition>

        <nav :class="['content-slider__nodes', { '-small': isSmall }]">
          <button
            v-for="index in slidesCount"
            :key="index"
            class="content-slider__goto"
            @click="$emit('index-change', index - 1)"
          />

          <span class="content-slider__goto -active" :style="activeNodeStyle" />
        </nav>

        <nav class="content-slider__menu">
          <button :class="getButtonClassName()" @click="$emit('index-change', currentIndex + 1)">
            <Icon id="arrow" />
          </button>

          <button
            :class="getButtonClassName(true)"
            @click="$emit('index-change', currentIndex - 1)"
          >
            <Icon id="arrow" />
          </button>
        </nav>
      </div>
    </template>
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'

export default {
  name: 'ContentSlider',
  components: { Icon, Image, RawHtml },
  props: {
    legend: { type: String, default: null },
    image: { type: Object, default: null },
    name: { type: String, default: null },
    title: { type: String, default: null },
    text: { type: String, default: null },
    slideTitle: { type: String, default: null },
    slideText: { type: String, default: null },
    links: { type: Array, default: [] },
    linksHeading: { type: String, default: null },
    currentIndex: { type: Number, default: 0 },
    slidesCount: { type: Number, default: 0 },
    sectionLegendClass: { type: [String, Array, Object], default: Array },
    isSmall: { type: Boolean, default: false },
  },
  data() {
    return {
      isRefReady: false,
    }
  },
  computed: {
    activeNodeStyle() {
      return { transform: `translate3d(${this.currentIndex * 2.25}rem, 0, 0)` }
    },
    legendClassName() {
      return ['section__legend', this.sectionLegendClass]
    },
    nameTitle() {
      return this.name || this.title
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.isRefReady = true
    })
  },
  methods: {
    getButtonClassName(isPrev) {
      return [
        'content-slider__button',
        {
          '-prev': isPrev,
          '-disabled': isPrev ? !this.currentIndex : this.currentIndex >= this.slidesCount - 1,
        },
      ]
    },
  },
}
</script>
